import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ActionsTab } from '@/app/(client)/capa/-components/ActionsTab';
import { PageContainer } from '@/components/shared/PageContainer';

// Mirrors the capa list route's schema (the params ActionsTab reads via
// `useSearch({ strict: false })` and writes via navigate), plus `limit` which
// `useTable` keeps in the URL for rows-per-page.
const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
  quickFilter: z
    .enum(['all', 'assignedToMe', 'reportedByMe', 'internal', 'external'])
    .optional(),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/capa',
)({
  validateSearch: searchSchema,
  component: CapaRoute,
});

function CapaRoute() {
  const { companyId } = Route.useParams();

  return (
    <PageContainer>
      <ActionsTab
        isArchived={false}
        defaultFilters={{ companyId }}
        tableId='company-capa-actions'
      />
    </PageContainer>
  );
}
